var React = require('react');

function Adventure (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0H42V42H0V0Z","fill":"white","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M21.1429 15.4467V18.1148L24.7143 14.5574L21.1429 11V13.668C17.1964 13.668 14 16.8519 14 20.7828C14 22.1791 14.4107 23.4775 15.1071 24.5714L16.4107 23.273C16.0089 22.5348 15.7857 21.6811 15.7857 20.7828C15.7857 17.8391 18.1875 15.4467 21.1429 15.4467ZM27.1786 17.4286L25.875 18.727C26.2679 19.4741 26.5 20.3189 26.5 21.2172C26.5 24.1609 24.0982 26.5533 21.1429 26.5533V23.8852L17.5714 27.4426L21.1429 31V28.332C25.0893 28.332 28.2857 25.1481 28.2857 21.2172C28.2857 19.8209 27.875 18.5225 27.1786 17.4286Z","fill":"#4C3371","key":1})]);
}

Adventure.defaultProps = {"width":"42","height":"42","viewBox":"0 0 42 42","fill":"none"};

module.exports = Adventure;

Adventure.default = Adventure;
